import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/arrow_black@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-a864618c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "search" }
const _hoisted_2 = { class: "viewport flex-center guideDom-pure-all-2" }
const _hoisted_3 = { class: "fx-1 flex-end" }
const _hoisted_4 = { class: "rel search-input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "abs",
  style: {"left":"78px","top":"1px","color":"var(--el-input-text-color, var(--el-text-color-regular))"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-down" })
], -1))
const _hoisted_6 = {
  key: 0,
  for: "upload_image",
  class: "flex-ter"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-search_filter1 ico-btn",
  style: {"cursor":"pointer","font-size":"14px"}
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "fx-1 search-btn guideDom-pure-all-3" }
const _hoisted_10 = { class: "tips" }
const _hoisted_11 = { id: "guideText" }
const _hoisted_12 = {
  key: 0,
  class: "guide-line"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import { ref, computed, reactive, onMounted, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useRtfix, useSite2Station, isEN } from '@/store'
import SellerCate from './SellerCate.vue'
import Particular from './Particular.vue'
import HotSearch from './HotSearch.vue'
import ChangePhone from './ChangePhone.vue'
import CartBtn from './CartBtn.vue'
import { isUrl } from '@/plugins/utils'
import { getMarketPlatList as getMarketPlatListRes } from '@/apis/market'
import { getTranslationText } from '@/apis/common'
import gbk from 'gbk-encode'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { bury } from '@/util/useBury'
import { uploadAliOSS, GOODS_IMAGE_SEARCH } from '@/util/useUpload'
import { searchByImage } from '@/util/useSearchByImage'
import { ElMessage } from 'element-plus'
import { Site } from '@/common/const'
import { SearchLangType } from '@/common/search'
import { searchProducts } from '@/apis/search'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import message from '@/store/modules/message'
import { Message } from '@element-plus/icons-vue'
import { confirmLoginWithNoCurShop } from '@/util/useConfirm'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const { encode } = gbk

const mutate = ref(1)
const site = useSite2Station()
const langTypeOtions = [
  {
    value: {
      [Site.JA]: SearchLangType.JA, // 日语
      [Site.KO]: SearchLangType.KR, // 韩语
      [Site.EN]: SearchLangType.EN // 英语
    }[site],
    label: {
      [Site.JA]: '日本语入力',
      [Site.KO]: '한국어 입력',
      [Site.EN]: 'English'
    }[site]
  },
  {
    value: SearchLangType.ZH,
    label: t('请输入中文')
  }
]

const router = useRouter()
const route = useRoute()
const store = useStore()

const buss = reactive(store.state.bussiness)
const langType = computed(() => buss.langType)
console.log(route, 'route')
const keyword = ref('')
watch(() => route.query.keyword, (val) => {
  val && (keyword.value = String(val))
}, { immediate: true })
const showHot = ref(0)
const searchRef = ref()
const particularRef = ref()
const partRef = ref()
const nullTrigger = ref(false)
const tipsVisabled = ref(false)
const guideTimer = ref()

onMounted(() => {
  // getMarketPlatList()
  handleGuidebtn()
  if (route.query.platformType) {
    store.commit('bussiness/platformType', route.query.platformType)
  }
  store.commit('bussiness/langType', langTypeOtions[0].value)
})
watch(langType, (val) => {
  localStorage.setItem('SearchLangType', val)
})
// 聚焦
const InputFocus = () => {
  bury('ALL_Click_SearchInput')
  showHot.value = 1
}

const iconSearch = () => {
  bury('ALL_Click_SiteSearch')
  const kw = keyword.value.trim()
  if (kw) {
    taTrack({
      event: TaEvent.PRODUCT_SEARCH,
      value: {
        search_content: keyword.value
      }
    })
  }
  handleSearch()
}

const handleSearch = async () => {
  particularRef.value.hide()
  const kw = keyword.value.trim()
  searchRef.value.blur()
  if (kw) {
    let query: any = {}
    if (isUrl(kw)) {
      query.detailUrl = encodeURIComponent(kw)
      reset(true)
      router.push({ ...route, query })
      // sku查询
    } else {
      if (/[a-zA-Z0-9]{28,36}/.test(kw) && store.getters.isLogin) {
        const res = await searchProducts({
          pageSize: 50,
          pageNum: 1,
          keyword: kw,
          stationCode: useSite2Station()
        })
        const records = res.data.records
        if (records.length === 1) {
          const productCode = records[0].productCode
          router.push(useRtfix('goods', { params: { id: productCode } }))
          return
        }
        console.log(res)
        // if()
      }
      buss.keyword = kw
      query = { ...store.getters['bussiness/model'], _t: Date.now() }
      // query.schannel = query.channel
      if (query.schannel === '0') {
        delete query.schannel
      }
      delete query.schannel
      reset()
      router[route.name?.toString().includes('list') ? 'replace' : 'push'](
        useRtfix('list', { query })
      )
    }
  } else {
    nullTrigger.value = true
    setTimeout(() => {
      searchRef.value.focus()
      nullTrigger.value = false
    }, 1500)
  }
}

const reset = (clear: boolean | void) => {
  store.commit('bussiness/sortType', '')
  store.commit('bussiness/sellPriceStart', '')
  store.commit('bussiness/sellPriceEnd', '')
  store.commit('bussiness/RESET_CONDITION')
  if (clear) {
    keyword.value = ''
  }
}
// 点击页面其他地方，搜索指南按钮提示内容消失
const handleGuidebtn = () => {
  // 通过document添加事件，通过dom的contains()判断guideBtn是否包含
  document.addEventListener('click', (e: any) => {
    const guideBtn = document.getElementById('guideBtn')
    if (buss.platformType === '') {
      if (guideBtn?.contains(e.target)) {
        tipsVisabled.value = true
        guideTimer.value = setTimeout(() => {
          tipsVisabled.value = false
        }, 5000)
      } else {
        tipsVisabled.value = false
        guideTimer.value = null
      }
    }
  })
}
const handleJump = (e: any) => {
  if (buss.platformType === 'PD') {
    // ElMessage.error(t('下载失败,文件不存在'))
    return
  }
  particularRef.value.hide()
  if (!store.getters.isInstall) {
    store.commit('extension/visible', true)
    return
  }
  const { sort, startPrice, endPrice, other } = buss.platCondition
  const arr: any = []
  const url = buss.externalLinks[buss.platformType]
  const key = buss.platformType === 'AM' ? 'keywords=' : 'q='

  /** 2024-06-27 添加逻辑 ws和vc跳转。英国站拦截 */
  if (['VC', 'WS'].includes(buss.platformType) && site === Site.EN) {
    ElMessage.error('Sorry, Easybuy Pluging cannot support WSY/VVIC.')
    return
  }

  if (buss.platformType === 'TB') {
    arr.push(
      // 'q=' + keyword.value,
      'sort=' + sort,
      'filter=' + `reserve_price[${startPrice},${endPrice}]`,
      ...other
    )
  } else if (buss.platformType === 'TM') {
    arr.push(
      // 'q=' + keyword.value,
      'sort=' + sort,
      'start_price=' + startPrice,
      'end_price=' + endPrice,
      ...other
    )
  } else if (buss.platformType === 'AM') {
    arr.push(
      // 'keywords=' + encode(keyword.value),
      'sortType=' + sort,
      'priceStart=' + startPrice,
      'priceEnd=' + endPrice,
      ...other
    )
  }

  if (['1', '3', '4'].includes(langType.value)) {
    const formData = {
      from: store.getters.site,
      to: 'zh',
      text: keyword.value
    }
    getTranslationText(formData).then((res: any) => {
      if (res.code === '0') {
        if (res.data === '') {
          arr.unshift(key + encodeKeyword(keyword.value))
        } else {
          arr.unshift(key + encodeKeyword(res.data))
        }
      } else {
        arr.unshift(key + encodeKeyword(keyword.value))
      }
      window.open(url + arr.join('&'))
    })
  } else {
    arr.unshift(key + encodeKeyword(keyword.value))
    window.open(url + arr.join('&'))
  }
}

// 如果是跳1688就encode
const encodeKeyword = (text: any) => {
  if (buss.productCategoryFrontendIdNameZh === undefined) {
    buss.productCategoryFrontendIdNameZh = ''
  }
  if (buss.platformType === 'AM') {
    return encode(text + ' ' + buss.productCategoryFrontendIdNameZh)
  } else {
    return text + ' ' + buss.productCategoryFrontendIdNameZh
  }
}

// 搜索历史框选中关键词
const hotSearchSelected = (key: string) => {
  keyword.value = key
}

// 获取市场购搜索平台
const getMarketPlatList = () => {
  if (buss.Sellers.some((v: any) => v.channel === '1')) {
    return
  }
  getMarketPlatListRes({ stationCode: site }).then((res) => {
    if (res.code === '0') {
      const sellerList = res.data.map((item: any) => {
        const label = {
          [Site.JA]: item.mallNameJp,
          [Site.KO]: item.mallNameKr,
          [Site.EN]: item.mallNameEn
        }[site] || item.mallNameZh
        return {
          label,
          value: 'SC' + item.productMallFrontendId,
          schannel: '1'
        }
      })
      store.commit('bussiness/UPDATE_SELLERS', [
        ...buss.Sellers,
        ...sellerList
      ])
    }
  })
}

// 图搜
const uploadImageRef = ref()
const choosePic = (e: any) => {
  const file = e.target.files[0]
  // 清空一下这个input的值不然选同一个文件不触发事件
  uploadImageRef.value.value = ''
  searchByImage(file).then(() => {
    reset(true)
  }).catch(() => {
    taTrack({
      event: TaEvent.PUPUP_WINDOW,
      value: {
        position: 'login',
        source: 'photo_search'
      }
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ChangePhone),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SellerCate, {
          class: _normalizeClass(["mr_30", { 'flash-trigget': tipsVisabled.value }]),
          style: {"border-radius":"17px","box-shadow":"0px 2px 10px 0px rgba(242,245,247,0.5)"}
        }, null, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_input, {
          class: _normalizeClass(["rel", { 'null-trigger': nullTrigger.value }]),
          ref: (_value, _refs) => {
            _refs['searchRef'] = _value
            searchRef.value = _value
          },
          placeholder: _unref(t)('商品链接或商品名'),
          type: "text",
          maxlength: "500",
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((keyword).value = $event)),
          title: keyword.value,
          onFocus: InputFocus,
          onBlur: _cache[6] || (_cache[6] = ($event: any) => (showHot.value = 0))
        }, {
          prefix: _withCtx(() => [
            _createVNode(_component_el_select, {
              defaultValue: _unref(langType),
              "model-value": _unref(langType),
              size: "small",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(bury)('ALL_Click_LanguageChose'))),
              style: {"width":"100px"},
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(store).commit('bussiness/langType', $event)))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(langTypeOtions, (lang) => {
                  return _createVNode(_component_el_option, {
                    size: "sime",
                    key: lang.value,
                    label: lang.label,
                    value: lang.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["defaultValue", "model-value"]),
            _hoisted_5
          ]),
          suffix: _withCtx(() => [
            (_unref(buss).schannel !== '1')
              ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _createElementVNode("i", {
                    class: "iconfont icon-search_camera1 ico-btn",
                    onClick: _cache[2] || (_cache[2] = () => {
                _unref(bury)('ALL_Click_SearchByImage');
                _unref(taTrack)({
                  event: _unref(TaEvent).BTN_CLICK,
                  value: {
                    position: 'photo_search'
                  }
                })
              }),
                    style: {"cursor":"pointer","font-size":"14px"}
                  }),
                  _withDirectives((_openBlock(), _createElementBlock("input", {
                    id: "upload_image",
                    type: "file",
                    key: mutate.value,
                    ref: (_value, _refs) => {
                      _refs['uploadImageRef'] = _value
                      uploadImageRef.value = _value
                    },
                    accept: "image/gif,image/png,image/jpeg,image/bmp,image/jpg",
                    onChange: choosePic
                  }, null, 544)), [
                    [_vShow, false]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_popover, {
              ref: (_value, _refs) => {
                _refs['particularRef'] = _value
                particularRef.value = _value
              },
              placement: "bottom-end",
              "popper-class": "particular",
              width: _unref(isEN)() ? 490 : 470,
              trigger: "click",
              "hide-after": 50,
              offset: 0
            }, {
              reference: _withCtx(() => [
                _createElementVNode("div", {
                  class: "pl_10 pr_10",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(bury)('ALL_Click_DetailedSearch')))
                }, _hoisted_8)
              ]),
              default: _withCtx(() => [
                _createVNode(Particular, {
                  modelValue: keyword.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((keyword).value = $event)),
                  onSearch: handleSearch,
                  onJump: handleJump,
                  onReset: reset,
                  ref: (_value, _refs) => {
                    _refs['partRef'] = _value
                    partRef.value = _value
                  }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["width"]),
            _createElementVNode("div", {
              class: "flex-ter rel pl_10 searchIcon",
              onClick: iconSearch
            }, [
              _createVNode(SvgIcon, {
                style: {"font-size":"18px","color":"#fff","margin-left":"5px"},
                class: "btn rel",
                name: "搜索"
              })
            ])
          ]),
          _: 1
        }, 8, ["class", "placeholder", "modelValue", "title"]),
        _createVNode(_Transition, {
          "enter-active-class": "animated fadeIn",
          "leave-active-class": "animated fadeOut"
        }, {
          default: _withCtx(() => [
            (showHot.value)
              ? (_openBlock(), _createBlock(HotSearch, {
                  key: 0,
                  modelValue: keyword.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((keyword).value = $event)),
                  onSelected: hotSearchSelected,
                  onHandleSearch: handleSearch
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_tooltip, {
          effect: "light",
          placement: "bottom",
          visible: tipsVisabled.value
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('使用tips')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(t)('1.指定采购来源')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(t)('2.选择商品类目或输入关键字')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(t)('3.即可前往指定采购来源站点搜索相关商品')), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "ml_10 ico-btn guide-btn",
              id: "guideBtn",
              type: "primary",
              disabled: !_unref(buss).platformType,
              onClick: handleJump
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(SvgIcon, {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(bury)('ALL_Click_OffSiteSearch'))),
                    style: {"font-size":"16px","outline":"none","margin-right":"6px"},
                    name: "外链"
                  }),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('站外搜索')), 1)
                ])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(CartBtn, { class: "ml_30 custom-plain" })
      ])
    ]),
    (tipsVisabled.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : _createCommentVNode("", true)
  ]))
}
}

})